import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { Button } from '../../../Button/Button.es.js';
import { Icon } from '../../../Icon/Icon.es.js';

const InputInlineIconButton = /*#__PURE__*/ forwardRef(({ name, onClick, className, align = 'left', disabled = false, size, label, ...rest }, ref)=>{
    const iconButtonClasses = useMemo(()=>{
        return classNames({
            disabled,
            [`align-${align ?? ''}`]: align
        }, 'input-icon-button', className);
    }, [
        align,
        className,
        disabled
    ]);
    const handleOnClick = useCallback((e)=>{
        e.stopPropagation();
        onClick?.(e);
    }, [
        onClick
    ]);
    return jsx(Button, {
        ref: ref,
        className: iconButtonClasses,
        disabled: disabled,
        label: label,
        onClick: handleOnClick,
        variant: "secondary",
        iconOnly: true,
        ...rest,
        children: jsx(Icon, {
            name: name,
            size: size
        })
    });
});
InputInlineIconButton.displayName = 'Input.Inline.IconButton';

export { InputInlineIconButton };
//# sourceMappingURL=Input.Inline.IconButton.es.js.map
